import FormSoddisfatto from "./FormSoddisfatto";
import { useState } from "react";
export default function Comp(props) {
  return (
    <>
      <h2 className="form_titolo center">
        Grazie per la tua opinione, lasciaci un
        consiglio per migliorarci!
      </h2>
      <FormSoddisfatto soddisfatto={true} />
    </>
  );
}
